import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("omnia_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("omnia_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => (i.product_id === product.id ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { product_id: product.id, name: product.name, price: product.price, cover: product.cover, qty }];
    });
  }, []);
  const setQty = useCallback((pid, qty) => setItems((prev) => prev.map((i) => (i.product_id === pid ? { ...i, qty: Math.max(1, qty) } : i))), []);
  const remove = useCallback((pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
